import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/workspace/tarbot/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageSelector"] */ "/workspace/tarbot/src/components/layout/language-selector.tsx");
